package com.cybersoftsolution.cybersoftsolutionweb.components.sections

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButton
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonType
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.ContentLayout
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.selectedColor
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.varabyte.kobweb.compose.css.FontVariantAlternates
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextShadow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.fontVariant
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textShadow
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.H4
import org.jetbrains.compose.web.dom.H5
import org.jetbrains.compose.web.dom.H6
import org.jetbrains.compose.web.dom.Text

@Composable
fun BannerSection(
    pageSection: PageSection,
    sectionModifier: Modifier = Modifier,
    contentModifier: Modifier = Modifier,
    brandIcon: String? = null,
    banner: String? = null,
    title: String = "",
    subtitle: String = "",
    text: String = "",
    buttonText: String = "",
    onButtonClick: () -> Unit = {},
) {


    ContentLayout(
        title = null,
        pageSection = pageSection,
        sectionModifier = sectionModifier,
        contentModifier = contentModifier
    ){

        SimpleGrid(
            modifier = Modifier
                .margin(topBottom = 10.px)
                .fillMaxWidth(),
//                    .fillMaxWidth(if (isDesktop()) {70.percent} else {100.percent}),
            numColumns = numColumns(base = 1, sm = 1, md = 1 , lg = 2 )
        ){
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.SpaceEvenly,
                modifier = Modifier.fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier.fillMaxWidth()
                ) {

                    H2  (
                        attrs = Modifier
                            .color(selectedColor)
                            .textAlign(TextAlign.Center)
                            .toAttrs()
                    ) {
                        Text(title)
                    }

                    HorizontalDivider()

                    H5   (
                        attrs = Modifier
                            .color(selectedColor)
//                            .textAlign(TextAlign.Center)
                            .toAttrs()
                    ) {
                        Text(subtitle)
                    }

                    H6    (
                        attrs = Modifier
                            .color(selectedColor)
                            .textAlign(TextAlign.Start)
                            .toAttrs()
                    ) {
                        Text(text)
                    }

                }
                Column(
                    modifier = Modifier.fillMaxWidth().margin(topBottom = 24.px)
                ) {

                    MyButton(
                        modifier = Modifier
                            .height(54.px)
                            .fillMaxWidth(),
                        id = "bannerButtonId",
                        buttonType = MyButtonType.Primary,
                        text = buttonText,
                        onClick = onButtonClick,
                        fontSize = 18
                    )

                }



            }


            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center,
                modifier = Modifier.fillMaxWidth()
            ) {

                Column(
                    horizontalAlignment = if (isDesktop()) Alignment.Start else  Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                ){
                    // Permite que el div se expanda
                    Div(Modifier.display(DisplayStyle.Flex).flexDirection(FlexDirection.Column).toAttrs()) {
                        Div(Modifier.flexGrow(1).toAttrs()){
                            Image(
                                modifier = Modifier
                                    .width(
                                        if (isDesktop()) 75.percent else 90.percent, //600.px,
                                    )
                                    .margin(topBottom = 24.px),
                                src = banner ?: "",
                                alt = "Banner Image",
                            )
                        }
                    }



                }
            }

        }


    }


}